import { Row, toGrammaticalNumber } from "@hex-insights/core";
import { Badge, BadgeProps } from "../../../../Components/Badge";
import { Icon } from "../../../../Components/Icon";

export type StudentsCountBadgeProps = Omit<BadgeProps, "children"> & {
	count: number;
	slim?: boolean;
};

export function StudentsCountBadge({ count, slim = false, ...props }: StudentsCountBadgeProps) {
	const StudentsIcon = count === 1 ? Icon.User : Icon.Users;

	return (
		<Badge {...props}>
			<Row justify="spaced-start" align="center" horizontalSpacing="0.25rem">
				<StudentsIcon size={16} /> {slim ? count : toGrammaticalNumber("Student", count, true)}
			</Row>
		</Badge>
	);
}
